import './Navbar.css';

const NAV_LINKS = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Soluções', href: '#solucoes' },
  // { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Contato', href: '#contato' },
];

const SOCIAL_LINKS = [
  {
    href: 'https://www.instagram.com/gerenciarsc/',
    label: 'Instagram',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <circle cx="12" cy="12" r="4.5" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    href: 'https://www.linkedin.com/company/gerenciarsc/',
    label: 'LinkedIn',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
        <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S.02 4.88.02 3.5 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8.5h4V24h-4V8.5zm7.5 0h3.84v2.14h.05c.53-1 1.83-2.14 3.76-2.14C19.9 8.5 21 11.07 21 14.43V24h-4v-8.57c0-2.04-.04-4.67-2.84-4.67-2.85 0-3.28 2.22-3.28 4.52V24H8V8.5z" />
      </svg>
    ),
  },
];

const LOGO_BEE = `${process.env.PUBLIC_URL}/logos/logo-branca-abelha.svg`;
const LOGO_TEXT = `${process.env.PUBLIC_URL}/logos/logo-branca-texto.svg`;

const Navbar = () => (
  <header className="navbar">

    <div className="navbar__left">
      <a href="#hero" className="navbar__logo" aria-label="Gerenciar — página inicial">
        <img src={LOGO_BEE} alt="" aria-hidden="true" className="navbar__logo-bee" />
        <img src={LOGO_TEXT} alt="Gerenciar" className="navbar__logo-text" />
      </a>
      <div className="navbar__social">
        {SOCIAL_LINKS.map(({ href, label, icon }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="navbar__social-link"
            aria-label={label}
          >
            {icon}
          </a>
        ))}
      </div>
    </div>

    <nav className="navbar__links" aria-label="Navegação principal">
      <ul>
        {NAV_LINKS.map(({ label, href }) => (
          <li key={href}>
            <a href={href}>{label}</a>
          </li>
        ))}
      </ul>
    </nav>

    <a href="https://wa.me/5531985558887" target="_blank" rel="noopener noreferrer" className="navbar__cta">
      Fale com um especialista
    </a>

  </header>
);

export default Navbar;
